import React  from 'react';
import { createPortal } from "react-dom";
import styles from './index.module.scss';
import css from './grid.module.css';
import cx from "classnames";
import ExpandableContentContainer from "./ExpandableContentContainer";
import Button from "../Button";
import Link from "../../CustomLink";
import {formatLinkUrl, parseIconUrl} from "../../../helpers/utils";
import PhotoGallery from "./PhotoGallery";
import NavigationHeader from "./NavigationHeader";
import DropdownNavigation from "./DropdownNavigation";
import RenderModal from "./RenderModal";

const RenderContent = ({type, content, innerContent, url, showPreview, theme}: DynamicObjectType) => {
  switch(type) {
    case 'TITLE': {
      if(content.textSize === 'XXL') return <h1 className={styles.h1}>{content.title}</h1>
      if(content.textSize === 'XL') return <h2 className={styles.h2}>{content.title}</h2>
      if(content.textSize === 'L') return <h3 className={styles.h3}>{content.title}</h3>
      if(content.textSize === 'M') return <h4 className={styles.h4}>{content.title}</h4>
      else return null
    }
    case 'PARAGRAPH': {
      return (
        <p className={styles.p}>{content.paragraph}</p>
      )
    }
    case 'BULLET_PARAGRAPH': {
      return (
        <p className={cx(styles.p, styles.bullet)}>{content.paragraph}</p>
      )
    }
    case 'WRAPPED_ROW': {
      if(!innerContent) return null
      return (
        <div className={styles.wrappedRow}>
          {innerContent.map((item, i) => <RenderContent {...item} key={i} />)}
        </div>
      )
    }
    case 'ROW': {
      if(!innerContent) return null
      return (
        <div className={styles.row}>
          {innerContent.map((item, i) => <RenderContent {...item} key={i} />)}
        </div>
      )
    }
    case 'PILL': {
      return (
        <Button text={content.title as string} theme={theme || 'dark_fill'} className={styles.pill} />
      )
    }
    case 'LINK': {
      if(!innerContent) return null
      if(content.action === 'openModal') {
        createPortal(null, document.getElementById("modal") as Element)
        return (
          <RenderModal params={content.params as {[key: string]: string} }>
            {innerContent?.map((item, i) => <RenderContent {...item} key={i} />)}
          </RenderModal>
        )
      }
      return (
        <Link to={formatLinkUrl(url || content.url as string)}>
          {innerContent?.map((item, i) => <RenderContent {...item} key={i} />)}
        </Link>
      )
    }
    case 'PHOTO': {
      const {url, altText} = content
      return (
        <img src={url} alt={altText} className={styles.image} />
      )
    }
    case 'PHOTO_GALLERY': {
      const items = content.items
      return (
        <PhotoGallery items={items} showPreview={showPreview as boolean} />
      )
    }
    case 'EXPANDABLE_CONTENT_CONTAINER': {
      if(!innerContent) return null
      return <ExpandableContentContainer items={innerContent} />
    }
    case 'ICON_PARAGRAPH': {
      return <div className={styles.flex}>
        {content.iconName && <img src={parseIconUrl(content.iconName)} alt={content.iconName}/>}
        <p className={styles.text}>{content.paragraph}</p>
      </div>
    }
    case 'NAVIGATION_HEADER': {
      return <NavigationHeader innerContent={innerContent as DynamicObjectType[]} content={content} />
    }
    case 'DROPDOWN_NAVIGATION': {
      const {placeholderText, data} = content as {placeholderText: string[], data: any};
      return <DropdownNavigation placeholderText={placeholderText} data={data} />
    }
    default: {
      if(/GRID[/d_]+/.test(type)) {
        if(!innerContent) return null
        const numbersList = type.split("_").filter(str => !isNaN(+str))
        const columns = window.matchMedia('(min-width: 768px)') ? numbersList[0] : numbersList[1]
        return <div className={css.grid} style={{
          // @ts-ignore
          '--grid-column-count': columns,
        }}>
          {innerContent.map((item, i) => <RenderContent {...item} key={i} />)}
        </div>
      }
      else return <div style={{width: '100%', height: 40, backgroundColor: 'red', marginBottom: 8}}/>
    }
  }
}

export default React.memo(RenderContent)
